const minDays = {
  0: 'Di',
  1: 'Lu',
  2: 'Ma',
  3: 'Me',
  4: 'Je',
  5: 'Ve',
  6: 'Sa',
  7: 'Fériés',
};

export default minDays;
